import React, { useEffect } from "react";
import "./style.scss";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setContact } from "../utils/store/reducers/authSlice";
import { getProfileDetailsRequest } from "../utils/apis/userApi";

function Layout({ children, headerName }) {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { idToken, contact } = useSelector((state) => state?.auth);

  useEffect(() => {
    if (!contact) {
      navigate("/profile/account-details");
    }
  }, [contact, idToken, location.pathname, navigate]);

  const fetchProfileDetails = async () => {
    try {
      const response = await getProfileDetailsRequest(idToken);
      if (response?.data?.contact) {
        dispatch(setContact(response.data.contact));
      }
    } catch (error) {
      console.error("Error fetching profile details:", error);
    }
  };

  useEffect(() => {
    if (!contact) {
      fetchProfileDetails();
    }
  }, [contact]); // Only re-fetch when `contact` is falsy

  return (
    <div className="layout">
      <Sidebar />
      <div className="layout_content">
        <Header headerName={headerName} />
        <div className="layout_children">{children}</div>
      </div>
    </div>
  );
}

export default Layout;
